import { VIEW_SIZE_REQUEST, VIEW_SIZE_SUCCESS, VIEW_SIZE_ERROR, RESET_VIEW_SIZE } from "../actions/viewSize"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const viewSize = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_SIZE_REQUEST:
            return {
                ...state,
                loading: true
            }

        case VIEW_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        case VIEW_SIZE_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case RESET_VIEW_SIZE:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }
        default:
            return state;
    }
}

export default viewSize